import {
  detachLayoutProps,
  WSMarginProps,
  WSSelect
} from "@wingspanhq/fe-component-library";
import { EngagementStatus } from "@wingspanhq/wingspan-api-sdk";
import { queriesEngagements } from "@query";
import { selectorEngagementOptions } from "../../../EngagementTypes/selectors/selectorEngagementOptions";

export const defaultCollaboratorGroupOption = {
  label: "Do not add contractors to group",
  value: "NONE"
};

type Props = WSMarginProps & {
  selectedEngagementId: string;
  onSelectEngagement: (option: { label: string; value: string } | null) => void;
};
export const SelectEngagementField: React.FC<Props> = ({
  selectedEngagementId,
  onSelectEngagement,

  ...otherProps
}) => {
  const { layoutProps } = detachLayoutProps(otherProps);

  const queryEngagements = queriesEngagements.listEngagements.useQueryAll(
    { filter: { status: { anyOf: [EngagementStatus.ACTIVE] } } },
    { refetchOnMount: false, retry: false }
  );

  const engagements = (queryEngagements.flatData || []).filter(
    e => !e.isDefault
  );

  const engagementOptions = selectorEngagementOptions(engagements);

  const handleSelectEngagement = (value: any) => {
    const engagement = engagementOptions.find(e => e.value === value);
    onSelectEngagement(engagement ?? null);
  };

  const showEngagementField = engagementOptions.length > 0;

  if (showEngagementField) {
    return (
      <WSSelect
        {...layoutProps}
        label="Engagement (optional)"
        value={selectedEngagementId}
        onChange={handleSelectEngagement}
        tooltip={{
          dark: true,
          title: "Engagement (optional)",
          children: `An engagement is a type of work arrangement that allows payers to organize their diverse work relationships in a flexible way. One engagement can be assigned when adding a new contractor. Other engagements can be added later.
            
    If you have not set up engagements or do not plan to use engagements, you can skip this field. Engagements can be updated in the Contractors section of the app at any time.`
        }}
        options={engagementOptions}
        internalSearch
        placeholder="Select an option"
      />
    );
  }

  return null;
};
